<template>
  <div class="pc-practiceDetail">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <div class="pc-practiceDetail-head">
      <div class="pc-practiceDetail-head-bread">
        <h2>BP管理</h2>
        <BreadCrumb :data="breadcrumb" class="pc-practiceDetail-breadcrumb" />
      </div>
      <h4 v-show="editUniversty == false" @click="edit">管理</h4>
      <h4
        v-show="editUniversty == true && bpType == 'update'"
        @click="
          edit();
          saveArea();
        "
      >
        完成
      </h4>
      <h4
        v-show="editUniversty == true && bpType == 'add'"
        @click="
          edit();
          addPractice();
        "
      >
        新增
      </h4>
    </div>
    <!-- 大学详情页基本信息 -->
    <div v-show="editUniversty == false" class="pc-practiceDetail-information">
      <h2>基本信息</h2>
      <div class="pc-practiceDetail-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-practiceDetail-information-contain-img">
          <div v-if="practiceDetail.coverImage != null" class="logo-Img">
            <img :src="practiceDetail.coverImage" />
          </div>
        </div>
        <!-- 右边文字内容 -->
        <ul class="pc-practiceDetail-information-contain-word">
          <li>
            <h4 class="choose">中文名 <span>*</span></h4>
            <span>{{ practiceDetail.title }}</span>
          </li>
          <li>
            <h4 class="choose">英文名<span>*</span></h4>
            <span>{{ practiceDetail.englishTitle }}</span>
          </li>
          <li>
            <h4 class="choose">设计师<span>*</span></h4>
            <span v-if="practiceDetail.author">{{
              practiceDetail.author.name
                ? practiceDetail.author.name
                : practiceDetail.author.englishName
            }}</span>
            <span v-if="!practiceDetail.author">暂无</span>
          </li>
          <li>
            <h4>事务所</h4>
            <span v-if="practiceDetail.company"
              >{{ practiceDetail.company }}
              {{ practiceDetail.englishCompany }}</span
            >
            <span v-if="!practiceDetail.company">暂无</span>
          </li>
          <li>
            <h4>所获奖项</h4>
            <span v-if="practiceDetail.award != null">{{
              practiceDetail.award.name
                ? practiceDetail.award.name
                : practiceDetail.award.englishName
            }}</span>
            <span v-if="practiceDetail.award == null">暂无</span>
          </li>
          <li class="area-li">
            <h4>地点</h4>
            <span>{{ practiceDetail.position }}</span>
          </li>
          <li>
            <h4>状态</h4>
            <!-- <span v-if="practiceDetail.status == 0">失效</span>
            <span v-if="practiceDetail.status == 1">有效</span> -->
            <el-switch
              v-model="practiceDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7 "
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改大学详情基本信息页 -->
    <div v-show="editUniversty == true" class="pc-practiceDetail-information">
      <h2>基本信息</h2>
      <div class="pc-practiceDetail-information-contain">
        <!-- 左边边图片 -->
        <div class="pc-practiceDetail-information-contain-img">
          <div class="pc-uploadLogoFile">
            <el-upload
              class="logoImg"
              :action="uploadUrl"
              list-type="picture-card"
              accept=".png,.PNG,.jpg,.JPG,.jpeg"
              :http-request="uploadLogoFile"
              :show-file-list="false"
              :auto-upload="true"
            >
              <img
                v-if="practiceDetail.coverImage"
                :src="practiceDetail.coverImage"
                class="upload-image"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="percentageCoverImage">
              <el-progress
                v-if="percentageCoverImage != 0"
                type="circle"
                :width="100"
                :percentage="percentageCoverImage"
              ></el-progress>
            </div>
          </div>

          <!-- <el-input v-model="practiceDetail.coverImage"></el-input> -->
        </div>
        <!-- 右边文字内容 -->
        <ul class="pc-practiceDetail-information-contain-word">
          <li>
            <h4 class="choose">中文名 <span>*</span></h4>
            <el-input
              v-model="practiceDetail.title"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li>
            <h4 class="choose">英文名<span>*</span></h4>
            <el-input
              v-model="practiceDetail.englishTitle"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li>
            <h4 class="choose">设计师<span>*</span></h4>
            <el-select
              v-if="practiceDetail.authorId != ''"
              v-model="practiceDetail.authorId"
              @change="choiceTeach"
            >
              <el-option
                v-for="(item, index) in teacherList"
                :key="index"
                :value="item.name ? item.id : item.id"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
            <el-select
              v-if="practiceDetail.authorId == ''"
              v-model="practiceDetail.authorId"
              @change="choiceTeach"
              placeholder="请选择设计师"
            >
              <el-option
                v-for="(item, index) in teacherList"
                :key="index"
                :value="item.name ? item.id : item.id"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </li>
          <li>
            <h4>事务所</h4>
            <el-input
              v-model="practiceDetail.company"
              style="width: 65%; margin-right: 10px"
              placeholder="请输入事务所名称"
              @blur="blurCompany"
            ></el-input>
            <el-input
              v-model="practiceDetail.englishCompany"
              placeholder="若填写为填写中文后自动翻译英文"
            ></el-input>
          </li>
          <li>
            <h4>所获奖项</h4>
            <!-- <el-input v-model="practiceDetail.award" placeholder="请选择"></el-input> -->
            <el-select
              v-if="practiceDetail.award != ''"
              v-model="practiceDetail.awardId"
              @change="choiceAward"
              placeholder="请选择奖项"
            >
              <el-option
                v-for="(item, index) in awardsList"
                :key="index"
                :value="item.name ? item.id : item.id"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
            <el-select
              v-if="practiceDetail.award == ''"
              v-model="practiceDetail.awardId"
              @change="choiceAward"
              placeholder="请选择设计师"
            >
              <el-option
                v-for="(item, index) in awardsList"
                :key="index"
                :value="item.name ? item.id : item.id"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </li>
          <li class="area-li">
            <h4>地域</h4>
            <el-input v-model="practiceDetail.position"></el-input>
          </li>
          <li>
            <h4>状态</h4>
            <el-switch
              v-model="practiceDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7 "
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 大学详情页院校标签 -->
    <TagDetail
      :dataDetail="practiceDetail"
      :managerState="managerState"
      :filterArr="filterArr"
      @updateTag="updateTag"
    />

    <!-- 院校详情 -->
    <EditDetail :isDetail="practiceDetail" :editUniversty="editUniversty" />

    <div class="pc-bp-button" v-show='editUniversty == true'>
        <h4 @click="getPractice(), editUniversty=false" v-show="bpType == 'update'">恢复</h4>
        <h4 @click="saveArea(), editUniversty=false">保存</h4>
      </div>
  </div>
</template>
<script>
// 页面模板
import TagDetail from "../../template/TagDetail";
import EditDetail from "../../template/EditDetail";
// 功能模板
import BreadCrumb from "../../template/BreadCrumb";
import TemplateUeditor from "../../template/Ueditor";
// gql接口部分
import {
  getPractice,
  getDictionaries,
  updatePractice,
  addPractice,
  getPersons,
} from "./bestPracticeList.gql";

import { getPracticeAwards } from "./awards.gql";
import { translate } from "../../template/graphql/translate.gql";
export default {
  components: {
    BreadCrumb,
    TemplateUeditor,
    TagDetail,
    EditDetail,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "BP管理", link: "/" },
        { name: "BP列表", link: "/admin/bestpractice" },
        {
          name: this.breadName ? this.breadName : null,
          link: "",
        },
      ];
    },
  },
  data() {
    return {
      percentageCoverImage: 0,
      imageUrl: "",
      // 上传图片初始URL
      bpType: "",
      // 上传图片
      uploadUrl: "",
      // 过滤标签数组
      filterArr: [],
      // 传入id
      practiceId: 0,
      practiceDetail: {
        tags: [],
        id: "",
        msgTitle: "BP",
        type: "BP",
        englishCompany: "",
      },
      // 判断当前是否需要编辑
      editUniversty: false,
      // 面包屑名字
      breadName: "",
      // 奖项接口后端需要的接口
      practiceAwardsArgs: {
        skip: 0,
        status: 1,
        take: 0,
        total: 0,
        cell: 0,
      },
      // 奖项列表
      awardsList: [],
      // 授课老师数组
      teacherList: [],
      // manager 编辑按钮
      managerState: false,
    };
  },
  mounted() {
    // console.log(this.$route.query.id);
    if (this.$route.query.id == null) {
      this.bpType = "add";
      this.edit();
    } else {
      this.practiceId = this.$route.query.id;
      this.bpType = "update";
      this.getPractice();
    }
    this.getPracticeAwards();
    this.getTeacherList();
  },
  methods: {
    // 奖项下拉框显示
    getPracticeAwards() {
      this.$global
        .GraphqlQuery(this, getPracticeAwards, this.practiceAwardsArgs)
        .then((res) => {
          this.practiceAwardsArgs.total = res.total;
          this.awardsList = res.data;
        });
    },
    getPractice() {
      this.$global
        .GraphqlQuery(this, getPractice, {
          // Parameters
          id: this.$route.query.id,
        })
        .then((res) => {
          this.practiceDetail = res.data[0];
          this.practiceDetail.msgTitle = "BP";
          this.breadName = this.practiceDetail.name;
          // 存储标签需要过滤的数组
          this.findFilterArr();
        });
    },
    // 存储标签需要过滤的数组
    findFilterArr() {
       this.filterArr = []
      if (this.practiceDetail.award) {

        this.practiceDetail.award.name &&
          this.filterArr.push(this.practiceDetail.award.name);
        this.practiceDetail.award.type &&
          this.filterArr.push(this.practiceDetail.award.type);

        this.practiceDetail.award.englishName &&
          this.filterArr.push(this.practiceDetail.award.englishName);
      }
      if (this.practiceDetail.author) {
        this.practiceDetail.author.name &&
          this.filterArr.push(this.practiceDetail.author.name);
        this.practiceDetail.author.englishName &&
          this.filterArr.push(this.practiceDetail.author.englishName);
      }
    },
    // 获取授课教师
    getTeacherList() {
      this.$global
        .GraphqlQuery(this, getPersons, {
          status: 1,
          order: "+englishName",
        })
        .then((res) => {
          this.teacherList = res.data;
        });
    },
    // 选择教师
    choiceTeach(id) {
      this.practiceDetail.authorId = id;
    },
    choiceAward(id) {
      this.practiceDetail.awardId = id;
    },
    //  输入事务所失去焦点
    blurCompany() {
      // var s = "allenglish";
      var re = new RegExp("^[a-zA-Z]+$");
      //要包含数字的话是 new RegExp("^[a-zA-Z0-9]+$");

      if (
        this.practiceDetail.company == "" ||
        this.practiceDetail.company == null
      ) {
      } else if (re.test(this.practiceDetail.company)) {
      } else {
        this.$global
          .GraphqlMutation(this, translate, {
            data: this.practiceDetail.company,
            flag: "1",
          })
          .then((res) => {
            if (res.data == "loading") {
              this.practiceDetail.englishCompany = "前面有人在翻译";
            } else {
              this.practiceDetail.englishCompany = res.data;
            }

          });
      }
    },
    // 上传头像
    async uploadLogoFile(params) {
      let that = this;
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          that.percentageCoverImage = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.percentageCoverImage = 0;
        this.$set(this.practiceDetail, "coverImage", res.url.split("?")[0]);
      });
      // this.$global.uploadImage(this, params).then(res => {
      //   this.practiceDetail.coverImage = res.split("?")[0];
      // });
    },
    //  院校图片
    uploadUniversties(params) {
      this.$global.uploadImage(this, params).then((res) => {
        // this.practiceDetail.logo = res.split('?')[0]
        this.practiceDetail.pictures.push({ image: res.split("?")[0] });
      });
    },
    // 点击编辑
    edit() {
      this.managerState = (this.managerState == false) == true ? true : false;
      this.editUniversty = (this.editUniversty == false) == true ? true : false;
    },
    // 新增bp
    addPractice() {
      let {
        title,
        englishTitle,
        company,
        position,
        logo,
        authorId,
        awardId,
        coverImage,
        status,
        tags,
        content,
        englishContent,
      } = this.practiceDetail;
      const subEntity = {
        title,
        englishTitle,
        company,
        position,
        authorId,
        awardId,
        logo,
        coverImage,
        status,
        tags,
        content,
        englishContent,
      };
      this.$global
        .GraphqlMutation(this, addPractice, {
          // Parameters
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.bpType = "update";
          this.practiceDetail.id = res.data[0].id;
          this.$router.push({
            path: "/admin/bestpracticedetail",
            query: { id: res.data[0].id },
            name: "bestpracticedetail",
            params: res.data[0],
          });
          this.getPractice();
        });
    },
    // 修改 管理 看看是否是空数据
    saveArea() {
      this.practiceDetail.title = this.$global.trimStr(
        this.practiceDetail.title
      );
      this.practiceDetail.englishTitle = this.$global.trimStr(
        this.practiceDetail.englishTitle
      );
      let {
        title,
        englishTitle,
        company,
        position,
        logo,
        authorId,
        awardId,
        englishCompany,
        coverImage,
        status,
        tags,
        content,
        englishContent,
      } = this.practiceDetail;
      const subEntity = {
        title,
        englishTitle,
        company,
        englishCompany,
        position,
        authorId,
        awardId,
        logo,
        coverImage,
        status,
        tags,
        content,
        englishContent,
      };
      this.$global
        .GraphqlMutation(this, updatePractice, {
          // Parameters
          id: this.practiceDetail.id,
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.loading = false;
          this.$global.success(this, "操作成功");
          this.getPractice();
        });
    },
    // 移除该标签
    removeTypeTag(index, id) {
      this.practiceDetail.tags.splice(index, 1);
    },
    // 子传父
    updateTag(updateTag) {
      this.practiceDetail.tags = updateTag;
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-practiceDetail {
  // 头部面包屑以及功能部分
  .pc-practiceDetail-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    margin-top: 30px;
    padding-bottom: 15px;
    .pc-practiceDetail-head-bread {
      display: flex;
      h2 {
        align-self: flex-end;
        font-size: 18px;
        margin-right: 40px;
      }
      .pc-breadcrumb {
        margin-top: 26px;
      }
    }
    h4 {
      align-self: flex-end;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  // 基本信息
  .pc-practiceDetail-information {
    box-shadow: $boxshadow;
    padding: 35px 30px 0px;
    margin-top: 40px;
    > h2 {
      border-bottom: 1px solid $border-color;
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    // 基本信息的内容框
    .pc-practiceDetail-information-contain {
      // border: 1px solid red;
      padding-top: 40px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .pc-practiceDetail-information-contain-img {
        display: flex;
        flex-direction: column;
        .pc-uploadLogoFile {
          position: relative;
          .percentageCoverImage {
            position: absolute;
            top: 50px;
            left: 50px;
          }
        }
        /deep/ .logoImg {
          .el-upload--picture-card {
            width: 200px;
            height: 200px;
            line-height: 200px;
            img {
              // width: 100%;
              width: 200px;
              height: 200px;
              object-fit: contain;
            }
          }
        }
        .logo-Img {
          width: 200px;
          height: 200px;
          display: flex;
          img {
            width: 100%;
            // height: 100%;
            object-fit: contain;
          }
        }
      }
      // 院校简介内容部分
      .pc-practiceDetail-information-contain-word {
        display: flex;
        flex-wrap: wrap;
        width: 70%;
        // justify-content: flex-end;
        li {
          display: flex;
          align-self: center;
          font-size: 14px;
          color: $mainTitle;
          font-family: $english;
          width: 50%;
          margin-bottom: 20px;
          h4 {
            width: 100px;
            min-width: 100px;
            text-align: right;
            margin-right: 20px;
            font-weight: 400;
            align-self: center;
          }
          .choose {
            display: flex;
            justify-content: flex-end;
            span {
              color: red;
              margin-left: 3px;
              margin-top: 2px;
              align-self: center;
              // line-height: 2;
            }
          }
          .el-form {
            display: flex;
            .el-select {
              margin-right: 20px;
            }
          }
          span {
            font-weight: 600;
            word-break: normal;
            width: auto;
            display: block;
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow: hidden;
            align-self: flex-start;
          }
        }
        // li:last-child {
        //   // width: 100%;
        //   position: relative;
        //   h4 {
        //     width: 100px;
        //     min-width: 100px;
        //     text-align: right;
        //     margin-right: 20px;
        //     font-weight: 400;
        //   }
        //   span {
        //     position: absolute;
        //     font-weight: 600;
        //     left: 120px;
        //     width: 224%;
        //   }
        // }
        .area-li {
          .area-li-div {
            display: flex;
            span {
              margin-right: 20px;
            }
          }
        }
      }
      // 院校简介内容底部的简介部分
      .pc-practiceDetail-information-contain-intro {
        /deep/ .el-textarea__inner {
          resize: none !important;
        }
      }
    }
  }
  .pc-bp-button {
    display: flex;
    justify-content: center;
    align-items: center;
    h4 {
      // margin-top: -10px;
      align-self: center;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 20px;
      margin-top: 40px;
    }
    h4:first-of-type {
      background: rgba(84, 112, 198, 0.14);
      color: $pageViewSmall;
      margin-right: 30px;
    }
    // h4:last-of-type{

    // }
  }
}
.el-input {
  .el-input__inner {
    border-color: #dcdfe6 !important;
  }
}
// elForm 弹出框的样式
// /deep/ .el-dialog {
//   width: 31%;
//   box-shadow: $boxshadow;
//   border-radius: 4px;
//   .el-form {
//     display: flex;
//     justify-content: space-around;
//   }
//   .el-dialog__footer {
//     padding: 10px 25% 20px;
//     .dialog-footer {
//       height: 28px;
//       display: flex;
//       justify-content: space-around;
//       .el-button--default:hover {
//         background: $base-color;
//       }
//       .el-button--default {
//         border-radius: 100px;
//         border: 1px solid $schoolTagBorder;
//         padding: 4px 24px;
//         span {
//           font-size: 12px;
//           color: $schoolTagColor;
//         }
//       }
//       .el-button--primary {
//         border-radius: 100px;
//         background: $pageViewSmall;
//         border: 1px solid $pageViewSmall;
//         padding: 4px 24px;
//         span {
//           font-size: 12px;
//           color: $base-color;
//         }
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/admin/bestPractice/BestPracticeDetail.vue